/**
 * Comments REST client (v4.1 Phase 38.1).
 *
 * All endpoints require a viewer+ role on the project (backend
 * enforces). Comment payload: { sectionId, content, parentId? }.
 */

import { request } from "./api.js";

export const listComments = (projectId, filename) =>
  request(
    `/api/projects/${projectId}/documents/${encodeURIComponent(filename)}/comments`,
  );

export const createComment = (projectId, filename, { sectionId, content, parentId }) =>
  request(
    `/api/projects/${projectId}/documents/${encodeURIComponent(filename)}/comments`,
    {
      method: "POST",
      body: JSON.stringify({ sectionId, content, parentId }),
    },
  );

export const editComment = (projectId, filename, commentId, { content }) =>
  request(
    `/api/projects/${projectId}/documents/${encodeURIComponent(filename)}/comments/${commentId}`,
    { method: "PATCH", body: JSON.stringify({ content }) },
  );

export const resolveComment = (projectId, filename, commentId) =>
  request(
    `/api/projects/${projectId}/documents/${encodeURIComponent(filename)}/comments/${commentId}/resolve`,
    { method: "POST" },
  );

export const reopenComment = (projectId, filename, commentId) =>
  request(
    `/api/projects/${projectId}/documents/${encodeURIComponent(filename)}/comments/${commentId}/reopen`,
    { method: "POST" },
  );

export const deleteComment = (projectId, filename, commentId) =>
  request(
    `/api/projects/${projectId}/documents/${encodeURIComponent(filename)}/comments/${commentId}`,
    { method: "DELETE" },
  );
